export function preview(s, h) {
  const rawItems =
    s.items ||
    (s.email || s.phone
      ? [
          ...(s.email ? [{ label: "Email", val: s.email, href: `mailto:${s.email}` }] : []),
          ...(s.phone ? [{ label: "Phone", val: s.phone, href: `tel:${s.phone}` }] : []),
        ]
      : []);
  const rows = rawItems.map((it) => [it.label || "", it.href || "", it.val || ""]);
  const ai = s.align === "left" ? "flex-start" : s.align === "right" ? "flex-end" : "center";
  const p = s.pad === "sm" ? "1.5rem 2rem" : s.pad === "lg" ? "4.5rem 2rem" : "2.5rem 2rem";
  const cst = s.cstyle || "normal";
  let inner;
  const subLine = (sub) =>
    sub
      ? `<span style="display:block;font-size:.62rem;font-weight:200;letter-spacing:.06em;color:${h.rgb(h.accent, 0.42)};margin-top:.12rem;">${h.E(sub)}</span>`
      : "";
  if (cst === "stacked") {
    inner = rawItems
      .map(
        (it) =>
          `<div style="display:flex;flex-direction:column;gap:.2rem;"><span style="font-size:.55rem;letter-spacing:.3em;text-transform:uppercase;color:${h.rgb(h.accent, 0.4)};font-weight:200;">${h.E(it.label || "")}</span><span style="font-size:.95rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.88)};">${h.E(it.val || "")}</span>${subLine(it.sub)}</div>`
      )
      .join("");
  } else if (cst === "minimal") {
    inner = rawItems
      .map(
        (it) =>
          `<div><a href="${h.A(it.href || "")}" style="font-size:.95rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.82)};text-decoration:none;">${h.E(it.val || "")}</a>${subLine(it.sub)}</div>`
      )
      .join("");
  } else {
    inner = rawItems
      .map(
        (it) =>
          `<div style="display:flex;align-items:baseline;gap:1rem;"><span style="font-size:.65rem;letter-spacing:.26em;text-transform:uppercase;color:${h.rgb(h.accent, 0.38)};min-width:3rem;text-align:right;font-weight:200;">${h.E(it.label || "")}</span><div><a href="${h.A(it.href || "")}" style="font-size:.92rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.85)};text-decoration:none;">${h.E(it.val || "")}</a>${subLine(it.sub)}</div></div>`
      )
      .join("");
  }
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:${s.align || "center"};"><div style="display:flex;flex-direction:column;align-items:${ai};gap:.8rem;">${inner}</div></div>`;
}
export function render(s, h) {
  const rawItems =
    s.items ||
    (s.email || s.phone
      ? [
          ...(s.email ? [{ label: "Email", val: s.email, href: `mailto:${s.email}` }] : []),
          ...(s.phone ? [{ label: "Phone", val: s.phone, href: `tel:${s.phone}` }] : []),
        ]
      : []);
  const rows = rawItems.map((it) => [it.label || "", it.href || "", it.val || ""]);
  const ai = s.align === "left" ? "flex-start" : s.align === "right" ? "flex-end" : "center";
  const p = s.pad === "sm" ? "1.5rem 2rem" : s.pad === "lg" ? "4.5rem 2rem" : "2.5rem 2rem";
  const cst = s.cstyle || "normal";
  const subLine = (sub) =>
    sub
      ? `<span style="display:block;font-size:.62rem;font-weight:200;letter-spacing:.06em;color:${h.rgb(h.accent, 0.42)};margin-top:.12rem;">${h.E(sub)}</span>`
      : "";
  let inner;
  if (cst === "stacked") {
    inner = rawItems
      .map(
        (it) =>
          `<div style="display:flex;flex-direction:column;gap:.2rem;"><span style="font-size:.55rem;letter-spacing:.3em;text-transform:uppercase;color:${h.rgb(h.accent, 0.4)};font-weight:200;">${h.E(it.label || "")}</span><span style="font-size:.95rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.88)};">${h.E(it.val || "")}</span>${subLine(it.sub)}</div>`
      )
      .join("");
  } else if (cst === "minimal") {
    inner = rawItems
      .map(
        (it) =>
          `<div><a href="${h.A(it.href || "")}" style="font-size:.95rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.82)};text-decoration:none;">${h.E(it.val || "")}</a>${subLine(it.sub)}</div>`
      )
      .join("");
  } else {
    inner = rawItems
      .map(
        (it) =>
          `<div style="display:flex;align-items:baseline;gap:1rem;"><span style="font-size:.65rem;letter-spacing:.26em;text-transform:uppercase;color:${h.rgb(h.accent, 0.38)};min-width:3rem;text-align:right;font-weight:200;">${h.E(it.label || "")}</span><div><a href="${h.A(it.href || "")}" style="font-size:.92rem;font-weight:300;letter-spacing:.06em;color:${h.rgb(h.text, 0.85)};text-decoration:none;">${h.E(it.val || "")}</a>${subLine(it.sub)}</div></div>`
      )
      .join("");
  }
  return `<div style="${h.ff}${h.fc}padding:${p};text-align:${s.align || "center"};"><div style="display:flex;flex-direction:column;align-items:${ai};gap:.8rem;">${inner}</div></div>`;
}
